/** Stable content adapter; authoring never rewrites this module. */
import { bindContent, contentCatalog } from "../content/catalog"
import type { ItemRecipe } from "./item"
export let itemRecipes = contentCatalog.items.recipes as ItemRecipe[]

// Rebuild the complete table group during preparation; activation only assigns bindings.
bindContent(catalog => ({
    itemRecipes: catalog.items.recipes as ItemRecipe[],
}), next => {
    itemRecipes = next.itemRecipes
})
